<template>
  <Page>
    <BSearch
      :search-list="searchList"
      @on-search="searchHandler"
    >
    </BSearch>
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      :rowKey="(text, index) => index"
      :scroll="{ x: true }"
      :columns="columns"
      :data="loadData"
    >
    </BTable>
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'UserAction',
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        const request = {
          ...this.queryParam,
          platCode: 'OMS'
        }
        return this.$http.action.businessLogQueryPage(Object.assign(parameter, { request })).then(response => {
          const { data } = response
          return data
        })
      },
      searchList: [
        // {
        //   label: '商户简称',
        //   key: 'interfaceName',
        //   type: 'select',
        //   options: []
        // },
        {
          label: '操作账号',
          key: 'account',
          type: 'input'
        }, { // 这个是接口没有
          label: '操作描述',
          key: 'status',
          type: 'input'
        }, {
          label: '操作日期',
          key: 'time',
          type: 'rangePicker'
        }
      ],
      columns: [
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        // {
        //   title: '商户简称',
        //   dataIndex: 'id' // no
        // },
        {
          title: '用户名称',
          dataIndex: 'userName'
          // sorter: true,
          // needTotal: true,
          // customRender: (text) => text + ' 次'
        },
        {
          title: '操作账号',
          dataIndex: 'account'
          // needTotal: true
        },
        {
          title: '访问路径', // 请求接口？
          dataIndex: 'requestUrl'
        },
        {
          title: '操作描述',
          // dataIndex: 'mailTo',
          customRender: () => '没有'
        },
        {
          title: '延时',
          dataIndex: 'intervalTime'
        },
        {
          title: '操作日期',
          dataIndex: 'createTime'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   width: '150px',
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  created () {
  },
  methods: {
    searchHandler (values) {
      this.queryParam = values
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style scoped lang="less">
</style>
